/* eslint-disable */
import React, { useEffect, useState } from 'react';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Button, Grid, CircularProgress, Box, Paper, Typography } from '@mui/material';
import LoginCard from 'ui-component/cards/LoginCard';
import { auth, encryptLocalStorageData, toastifySuccess } from 'helper/Utility';
import { useNavigate } from 'react-router';
import { INVOICE_APICALL } from 'helper/api/api';
import bluelogo from '../../assets/images/bluelogo.png';
import Alert from '@mui/material/Alert';

// Background image - you can replace with your own image URL
import bgImage from '../../assets/images/login-bg.jpg';

function Login() {
  const [Email, SetEmail] = useState('');
  const [Password, SetPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [msg, setMsg] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [stage, setStage] = useState('login');
  const [otp, setOtp] = useState('');
  const [qrCode, setQrCode] = useState(null);
  const [tempToken, setTempToken] = useState(null);

useEffect(() => {

  // ── Salesperson already logged in → redirect ──
  const spAuthData = auth('salesperson');

  if (
    spAuthData?.token &&
    spAuthData?.role === 'salesperson'
  ) {

    navigate('/salesperson/dashboard', { replace: true });
    return;
  }

  // ── Admin / HR already logged in → redirect ──
  const authData = auth('admin');

  if (authData?.token) {

    if (authData?.role === 'hr') {

      navigate('/hr/expenses', { replace: true });

    } else if (
      authData?.is2FAVerified &&
      authData?.role === 'admin'
    ) {

      navigate('/admin/dashboard', { replace: true });

    } else {

      // Clear stale sessions
      localStorage.removeItem('admin-secret');
      localStorage.removeItem('salesperson-secret');
    }
  }

}, [navigate]);


  // ── Step 1: Login ──────────────────────────────────────────────────────────
useEffect(() => {

  // ── Salesperson already logged in → redirect ──
  const spAuthData = auth('salesperson');

  if (
    spAuthData?.token &&
    spAuthData?.role === 'salesperson'
  ) {

    navigate('/salesperson/dashboard', { replace: true });
    return;
  }

  // ── Admin / HR already logged in → redirect ──
  const authData = auth('admin');

  if (authData?.token) {

    if (authData?.role === 'hr') {

      navigate('/hr/expenses', { replace: true });

    } else if (
      authData?.is2FAVerified &&
      authData?.role === 'admin'
    ) {

      navigate('/admin/dashboard', { replace: true });

    } else {

      // Clear stale sessions
      localStorage.removeItem('admin-secret');
      localStorage.removeItem('salesperson-secret');
    }
  }

}, [navigate]);




// ── LOGIN PROCESS ─────────────────────────────────────────────────────
const loginprocess = async () => {

  if (!Email || !Password) {
    setMsg('Please enter Email and Password');
    return;
  }

  setMsg(null);
  setLoading(true);

  try {

    const res = await INVOICE_APICALL(
      'admin/adminLogin',
      'post',
      {
        email: Email,
        password: Password
      }
    );

    console.log('Login response:', res);

    if (res?.status === 200) {

      const role = res?.data?.role || res?.role;

const dataParam = {
  token: res?.token,
  firstName: res?.data?.firstName,
  lastName: res?.data?.lastName,
  email: res?.data?.email,
  id: res?.data?._id,
  role: res?.data?.role || 'salesperson',
};

      // ─────────────────────────────────────────────
      // 2FA FLOW
      // ─────────────────────────────────────────────

      if (res?.requires2FA === true) {

        setTempToken(res?.token);

        encryptLocalStorageData(
          'admin-secret',
          {
            ...dataParam,
            is2FAVerified: false
          },
          'DoNotTryToAccess'
        );

        if (res?.needs2FASetup === true) {

          await getQRCodeForSetup(res?.token);

        } else {

          setStage('verify2fa');
          setLoading(false);
        }

      } else {

        // ─────────────────────────────────────────────
        // DIRECT LOGIN
        // ─────────────────────────────────────────────

        toastifySuccess('Login successful!');

        // ✅ SALESPERSON LOGIN
        if (role === 'salesperson') {

          encryptLocalStorageData(
            'salesperson-secret',
            {
              ...dataParam,
              role: 'salesperson',
              is2FAVerified: true
            },
            'DoNotTryToAccess'
          );


          navigate('/salesperson/dashboard', {
            replace: true
          });

        }

        // ✅ HR LOGIN
        else if (role === 'hr') {

          encryptLocalStorageData(
            'admin-secret',
            {
              ...dataParam,
              role: 'hr',
              is2FAVerified: true
            },
            'DoNotTryToAccess'
          );

          navigate('/hr/expenses', {
            replace: true
          });

        }

        // ✅ ADMIN LOGIN
// ✅ ADMIN LOGIN
else {

  encryptLocalStorageData(
    'admin-secret',              // ✅ correct key
    {
      ...dataParam,
      role: 'admin',             // ✅ correct role
      is2FAVerified: true
    },
    'DoNotTryToAccess'
  );

  navigate('/admin/dashboard', {
    replace: true
  });

}

      }

    } else {

      setMsg(res?.message || 'Login failed');
      setLoading(false);

    }

  } catch (error) {

    console.error(error);

    setMsg(
      error?.response?.data?.message ||
      'Login failed. Please try again.'
    );

    setLoading(false);

  }

};

  // ── Step 2a: Get QR Code ───────────────────────────────────────────────────
  const getQRCodeForSetup = async (token) => {
    if (!token) {
      setMsg('Authentication error. Please login again.');
      setStage('login');
      setLoading(false);
      return;
    }

    try {
      const res = await INVOICE_APICALL('admin/setup-2fa', 'post', {}, token);
      console.log('Setup 2FA response:', res);

      if (res?.status === 200 || res?.status) {
        setQrCode(res?.qrCode);
        setOtp('');
        setStage('setup2fa');
        setMsg(null);
      } else {
        setMsg(res?.message || '2FA setup failed. Please contact support.');
        setStage('login');
      }
    } catch (err) {
      setMsg(err?.response?.data?.message || err?.message || 'Failed to setup 2FA. Please try again.');
      setStage('login');
    } finally {
      setLoading(false);
    }
  };

  // ── Step 2b: Verify OTP — First time setup ────────────────────────────────
  const handleVerifyAndEnable2FA = async () => {
    if (!otp || otp.length !== 6) {
      setMsg('Please enter a valid 6-digit OTP.');
      return;
    }
    setMsg(null);
    setLoading(true);

    try {
      const tokenToUse = tempToken || auth('admin')?.token;

      if (!tokenToUse) {
        setMsg('Session expired. Please login again.');
        setStage('login');
        setLoading(false);
        return;
      }

      const res = await INVOICE_APICALL('admin/verify-2fa', 'post', { otp }, tokenToUse);
      console.log('Verify 2FA response:', res);

      if (res?.status === 200 || res?.status) {
        const currentAuth = auth('admin');
        encryptLocalStorageData(
          'admin-secret',
          { ...currentAuth, is2FAVerified: true, token: tokenToUse },
          'DoNotTryToAccess'
        );
        toastifySuccess(res?.message || '2FA enabled successfully!');
        // Redirect based on role
        if ((res?.role || currentAuth?.role) === 'hr') {
          navigate('/hr/expenses', { replace: true });
        } else {
          navigate('/admin/dashboard', { replace: true });
        }
      } else {
        setMsg(res?.message || 'Invalid OTP. Please try again.');
      }
    } catch (err) {
      setMsg(err?.response?.data?.message || err?.message || 'OTP verification failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  // ── Step 2c: Verify OTP — Already setup users (HAR LOGIN PE) ─────────────
  const handleVerifyOTP = async () => {
    if (!otp || otp.length !== 6) {
      setMsg('Please enter a valid 6-digit OTP.');
      return;
    }
    setMsg(null);
    setLoading(true);

    try {
      const tokenToUse = tempToken || auth('admin')?.token;

      if (!tokenToUse) {
        setMsg('Session expired. Please login again.');
        setStage('login');
        setLoading(false);
        return;
      }

      const res = await INVOICE_APICALL('admin/validate-otp', 'post', { otp }, tokenToUse);

      if (res?.status === 200) {
        const currentAuth = auth('admin');
        encryptLocalStorageData(
          'admin-secret',
          { ...currentAuth, is2FAVerified: true, token: tokenToUse },
          'DoNotTryToAccess'
        );
        toastifySuccess('Login successful!');
        // Redirect based on role
        if ((res?.role || currentAuth?.role) === 'hr') {
          navigate('/hr/expenses', { replace: true });
        } else {
          navigate('/admin/dashboard', { replace: true });
        }
      } else {
        setMsg(res?.message || 'Invalid OTP. Please try again.');
      }
    } catch (err) {
      const errData = err?.response?.data;
      if (errData?.code === '2FA_NOT_CONFIGURED') {
        sessionStorage.removeItem('admin-secret');
        setTempToken(null);
        setStage('login');
        setMsg('Session expired or 2FA was reset. Please login again.');
      } else {
        setMsg(errData?.message || err?.message || 'OTP verification failed.');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      if (stage === 'login') loginprocess();
      if (stage === 'setup2fa') handleVerifyAndEnable2FA();
      if (stage === 'verify2fa') handleVerifyOTP();
    }
  };

  const goBackToLogin = () => {
    setStage('login');
    setOtp('');
    setMsg(null);
    setQrCode(null);
    setTempToken(null);
  };

  // Render different content based on stage
  const renderContent = () => {
    switch (stage) {
      case 'login':
        return (
          <>
            <Box sx={{ textAlign: 'center', mb: 3 }}>
              <img src={bluelogo} alt="Logo" style={{ width: '180px', height: 'auto' }} />
            </Box>

            <Typography variant="h5" fontWeight={700} textAlign="center" gutterBottom>
              Welcome Back!
            </Typography>
            <Typography variant="body2" color="text.secondary" textAlign="center" sx={{ mb: 3 }}>
              Sign in to continue to your account
            </Typography>

            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="subtitle2" fontWeight={600} gutterBottom>
                  Email Address
                </Typography>
                <FormControl fullWidth>
                  <OutlinedInput
                    placeholder="admin@example.com"
                    value={Email}
                    onChange={(e) => SetEmail(e.target.value)}
                    onKeyDown={handleKeyDown}
                    sx={{ borderRadius: 2 }}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <Typography variant="subtitle2" fontWeight={600} gutterBottom>
                  Password
                </Typography>
                <FormControl fullWidth>
                  <OutlinedInput
                    placeholder="Enter your password"
                    type={showPassword ? 'text' : 'password'}
                    value={Password}
                    onChange={(e) => SetPassword(e.target.value)}
                    onKeyDown={handleKeyDown}
                    sx={{ borderRadius: 2 }}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton onClick={() => setShowPassword(p => !p)} edge="end">
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </FormControl>
              </Grid>

              {msg && (
                <Grid item xs={12}>
                  <Alert severity="error" sx={{ borderRadius: 2 }}>{msg}</Alert>
                </Grid>
              )}

              <Grid item xs={12}>
                <Button
                  fullWidth
                  variant="contained"
                  onClick={loginprocess}
                  disabled={loading}
                  sx={{
                    py: 1.5,
                    borderRadius: 2,
                    textTransform: 'none',
                    fontWeight: 600,
                    fontSize: '1rem',
                    mt: 1
                  }}
                >
                  {loading ? <CircularProgress size={24} color="inherit" /> : 'Sign In'}
                </Button>
              </Grid>
            </Grid>
          </>
        );

      case 'setup2fa':
        return (
          <>
            <Box sx={{ textAlign: 'center', mb: 3 }}>
              <img src={bluelogo} alt="Logo" style={{ width: '180px', height: 'auto' }} />
            </Box>

            <Typography variant="h5" fontWeight={700} textAlign="center" color="#e53e3e" gutterBottom>
              ⚠️ 2FA Setup Required
            </Typography>
            <Typography variant="body2" color="text.secondary" textAlign="center" sx={{ mb: 2 }}>
              This is a <strong>one-time mandatory setup</strong>. You will only see this once.
            </Typography>

            <Paper sx={{ p: 2, bgcolor: '#f0fdf4', mb: 2, borderRadius: 2 }}>
              <Typography variant="body2" color="success.main" sx={{ mb: 1 }}>
                <strong>How to set up:</strong>
              </Typography>
              <Typography variant="caption" component="div" color="text.secondary" sx={{ pl: 2 }}>
                1. Install <strong>Google Authenticator</strong> on your phone<br />
                2. Tap <strong>"+"</strong> and scan the QR code below<br />
                3. Enter the 6-digit code shown in the app
              </Typography>
            </Paper>

            {qrCode ? (
              <Box sx={{ textAlign: 'center', mb: 2 }}>
                <img
                  src={qrCode}
                  alt="2FA QR Code"
                  style={{
                    width: 200,
                    height: 200,
                    margin: 'auto',
                    display: 'block',
                    borderRadius: 12,
                    border: '2px solid #e2e8f0',
                    padding: 10,
                  }}
                />
              </Box>
            ) : (
              <Box sx={{ textAlign: 'center', py: 3 }}>
                <CircularProgress />
                <Typography variant="body2" sx={{ mt: 1 }}>Loading QR code...</Typography>
              </Box>
            )}

            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="subtitle2" fontWeight={600} gutterBottom>
                  Enter 6-digit Code
                </Typography>
                <FormControl fullWidth>
                  <OutlinedInput
                    placeholder="000000"
                    value={otp}
                    inputProps={{
                      inputMode: 'numeric',
                      pattern: '[0-9]*',
                      maxLength: 6,
                      style: { fontSize: '24px', textAlign: 'center', letterSpacing: '5px' },
                    }}
                    onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
                    onKeyDown={handleKeyDown}
                    autoFocus
                    sx={{ borderRadius: 2 }}
                  />
                </FormControl>
              </Grid>

              {msg && (
                <Grid item xs={12}>
                  <Alert severity="error" sx={{ borderRadius: 2 }}>{msg}</Alert>
                </Grid>
              )}

              <Grid item xs={12}>
                <Button
                  fullWidth
                  variant="contained"
                  onClick={handleVerifyAndEnable2FA}
                  disabled={loading || !qrCode}
                  sx={{
                    py: 1.5,
                    borderRadius: 2,
                    textTransform: 'none',
                    fontWeight: 600,
                    bgcolor: '#10b981',
                    '&:hover': { bgcolor: '#059669' }
                  }}
                >
                  {loading ? <CircularProgress size={24} color="inherit" /> : '✓ Activate 2FA'}
                </Button>
              </Grid>

              <Grid item xs={12} sx={{ textAlign: 'center' }}>
                <Button
                  variant="text"
                  size="small"
                  onClick={goBackToLogin}
                  sx={{ color: '#6b7280', textTransform: 'none' }}
                >
                  ← Back to Login
                </Button>
              </Grid>
            </Grid>
          </>
        );

      case 'verify2fa':
        return (
          <>
            <Box sx={{ textAlign: 'center', mb: 3 }}>
              <img src={bluelogo} alt="Logo" style={{ width: '180px', height: 'auto' }} />
            </Box>

            <Typography variant="h5" fontWeight={700} textAlign="center" gutterBottom>
              🔐 Two-Factor Authentication
            </Typography>
            <Typography variant="body2" color="text.secondary" textAlign="center" sx={{ mb: 3 }}>
              Open <strong>Google Authenticator</strong> and enter the 6-digit code
            </Typography>

            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="subtitle2" fontWeight={600} gutterBottom>
                  Verification Code
                </Typography>
                <FormControl fullWidth>
                  <OutlinedInput
                    placeholder="000000"
                    value={otp}
                    inputProps={{
                      inputMode: 'numeric',
                      pattern: '[0-9]*',
                      maxLength: 6,
                      style: { fontSize: '24px', textAlign: 'center', letterSpacing: '5px' },
                    }}
                    onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
                    onKeyDown={handleKeyDown}
                    autoFocus
                    sx={{ borderRadius: 2 }}
                  />
                </FormControl>
              </Grid>

              {msg && (
                <Grid item xs={12}>
                  <Alert severity="error" sx={{ borderRadius: 2 }}>{msg}</Alert>
                </Grid>
              )}

              <Grid item xs={12}>
                <Button
                  fullWidth
                  variant="contained"
                  onClick={handleVerifyOTP}
                  disabled={loading}
                  sx={{
                    py: 1.5,
                    borderRadius: 2,
                    textTransform: 'none',
                    fontWeight: 600,
                    fontSize: '1rem'
                  }}
                >
                  {loading ? <CircularProgress size={24} color="inherit" /> : '✓ Verify & Sign In'}
                </Button>
              </Grid>

              <Grid item xs={12} sx={{ textAlign: 'center' }}>
                <Button
                  variant="text"
                  size="small"
                  onClick={goBackToLogin}
                  sx={{ color: '#6b7280', textTransform: 'none' }}
                >
                  ← Back to Login
                </Button>
              </Grid>
            </Grid>
          </>
        );

      default:
        return null;
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${bgImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed',
        position: 'relative',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.3)',
        }
      }}
    >
      <Grid container justifyContent="center" alignItems="center" sx={{ position: 'relative', zIndex: 1 }}>
        <Grid item xs={11} sm={8} md={5} lg={4}>
          <Paper
            elevation={24}
            sx={{
              borderRadius: 4,
              overflow: 'hidden',
              backdropFilter: 'blur(10px)',
              backgroundColor: 'rgba(255, 255, 255, 0.95)',
            }}
          >
            <Box sx={{ p: 4 }}>
              {renderContent()}
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Login;